import React, { PureComponent } from 'react';
import { Button, DialogContainer } from 'react-md';
import { connect } from 'react-redux';
import { setDialogVisibility } from '../../actions/dialog.action';
import './DeactivateModal.scss';

class DeactivateModal extends PureComponent {
  hide = () => {
    this.props.setDialogVisibility({ visibility: false });
  };

  handleConfirm = () => {
    const { title } = this.props.data;
    if (title === 'Organizations') {
      this.props.data.action(this.props.data.data);
    } else {
      this.props.deactivateUser(this.props.data.data);
    }
    this.props.setDialogVisibility({ visibility: false });
  };

  render() {
    const deactivateTitle = {
      Organizations: 'Deactivate organization?',
      People: 'Deactivate User?'
    };

    let subTitle;
    if (this.props.title === 'PERSON' && this.props.visible) {
      const { displayName, relationships } = this.props.data.data;
      const relationshipArray = relationships.map(r => r.displayName);
      const relString =
        relationshipArray.length === 0
          ? 'no organizations'
          : relationshipArray.join(', ');
      subTitle = `${displayName} is associated to ${relString} and will lose permission to access their data.`;
    } else {
      subTitle = 'This relationship will be deactivated in the database.';
    }

    return (
      <DialogContainer
        id='deactivate-dialog'
        aria-labelledby='deactivate-dialog'
        visible={this.props.visible}
        onHide={this.hide}
        title={this.props.data && deactivateTitle[this.props.data.title]}
      >
        <p>{subTitle}</p>
        <div className='deactivate-button-container'>
          <Button
            className='deactivate-cancel'
            flat
            primary
            onClick={this.hide}
          >
            Cancel
          </Button>
          <Button
            className='deactivate-confirm'
            flat
            primary
            onClick={this.handleConfirm}
          >
            Confirm
          </Button>
        </div>
      </DialogContainer>
    );
  }
}

const mapStateToProps = state => ({
  data: state.dialog.data
});

export default connect(
  mapStateToProps,
  {
    setDialogVisibility
  }
)(DeactivateModal);



// WEBPACK FOOTER //
// ./src/components/DeactivateModal/DeactivateModal.jsx